<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
	  		 <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;"><img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />菜单管理</el-col>
	  		 <el-col :xs="24" :md="18">
	  			<el-form style="text-align: right;" :model="dataForm" @keyup.enter.native="getDataList()">
	  			  <el-form-item>
	  			    <el-button class="addBtn" v-if="$hasPermission('sys:menu:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
	  			  </el-form-item>
	  			</el-form>
	  		 </el-col>
	  </el-row>
    <div class="mod-sys__menu" style="padding-bottom: 20px;">

      <el-table v-loading="dataListLoading" :data="dataList" row-key="id" style="width: 100%;">
        <el-table-column prop="name" :label="$t('menu.name')" header-align="center" min-width="150"></el-table-column>
        <el-table-column prop="icon" :label="$t('menu.icon')" header-align="center" align="center">
          <template slot-scope="scope">
            <svg class="icon-svg" aria-hidden="true"><use :xlink:href="`#${scope.row.icon}`"></use></svg>
          </template>
        </el-table-column>
        <el-table-column prop="type" :label="$t('menu.type')" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.type === 0" size="small">{{ $t('menu.type0') }}</el-button>
            <el-button type="text" v-else size="small">{{ $t('menu.type1') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否显示" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.isShow === 1" size="small">显示</el-button>
            <el-button type="text" v-else size="small">不显示</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="sort" :label="$t('menu.sort')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="url" :label="$t('menu.url')" header-align="center" align="center" width="150" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="permissions" :label="$t('menu.permissions')" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column  :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:menu:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:menu:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './menu-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/menu/list',
        deleteURL: '/sys/menu'
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
